import * as React from 'react';
import './src/styles/globals.scss';
import './src/styles/consent.scss';
import App from './src/App';
import { GatsbyBrowser } from 'gatsby';

export const wrapRootElement: GatsbyBrowser['wrapRootElement'] =
    ({ element }) => (<App>{element}</App>);
